import React from 'react';
import styles from '@/views/Layout/internal/InternalNavBar/index.module.css';
import {
  MenuFor,
  LabelFor,
  MainMenuFor,
  DropdownMainMenu,
} from '@/views/Layout/internal/InternalNavBar/detectMenu';

const ServiceNavContent = () => (
  <div className={styles.megamenu}>
    <LabelFor name='servicing' label='Servicing' />
    <ul>
      <li>
        <MenuFor name='policyList' type='subMenu' label='Policy' />
        <MenuFor
          name='newPolicy'
          type='subMenu'
          label='/ New Policy'
          style={{marginLeft: '3px'}}
        />
        <br />
        <MenuFor
          name='newFundAccount'
          type='subMenu'
          label='New Fund Account'
          style={{marginLeft: '48px'}}
        />
        <br />
        <MenuFor
          name='portfoiloVariation'
          type='subMenu'
          label='Portfoilo Variation'
          style={{marginLeft: '48px'}}
        />
      </li>
      <li>
        <MenuFor name='followUp' type='subMenu' label='Follow Up' />
      </li>
    </ul>
    <br />
    <LabelFor name='clientAndProducer' label='Client & Producer' />
    <ul>
      <li>
        <MenuFor name='client' type='subMenu' label='Client' />
        <MenuFor
          name='newClient'
          type='subMenu'
          label='/ New'
          style={{marginLeft: '3px'}}
        />
      </li>
      <li>
        <MenuFor name='producerList' type='subMenu' label='Producer' />
        <MenuFor
          name='newChannel'
          type='subMenu'
          label='/ New Channel'
          style={{marginLeft: '3px'}}
        />
        <br />
        <MenuFor
          name='newConsultant'
          type='subMenu'
          label='New Consultant'
          style={{marginLeft: '68px'}}
        />
        <br />
        <MenuFor
          name='trainingHistory'
          type='subMenu'
          label='Training History'
          style={{marginLeft: '68px'}}
        />
        <br />
        <MenuFor
          name='rankSetup'
          type='subMenu'
          label='Rank Setup'
          style={{marginLeft: '68px'}}
        />
      </li>
    </ul>
    <br />
    <LabelFor name='master' label='Master' />
    <ul>
      <li>
        <MenuFor name='providerList' type='subMenu' label='Provider' />
        <MenuFor
          name='newProvider'
          type='subMenu'
          label='/ New'
          style={{marginLeft: '3px'}}
        />
      </li>
      <li>
        <MenuFor name='productList' type='subMenu' label='Product' />
        <MenuFor
          name='newProduct'
          type='subMenu'
          label='/ New'
          style={{marginLeft: '3px'}}
        />
      </li>
      <li>
        <MenuFor name='fundList' type='subMenu' label='Fund' />
        <MenuFor
          name='newFund'
          type='subMenu'
          label='/ New'
          style={{marginLeft: '3px'}}
        />
      </li>
      <li>
        <MenuFor name='currencyList' type='subMenu' label='Currency' />
        <MenuFor
          name='newCurrency'
          type='subMenu'
          label='/ New'
          style={{marginLeft: '3px'}}
        />
      </li>
    </ul>
  </div>
);

const ServiceNav = () => (
  <MainMenuFor name='service'>
    <DropdownMainMenu name='service' label='Service'>
      <ServiceNavContent />
    </DropdownMainMenu>
  </MainMenuFor>
);

export default ServiceNav;
